import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import {FormGroup, FormControl} from '@angular/forms';
import * as  moment from 'moment';


@Component({
  selector: 'fury-lead-partner-performance-list',
  templateUrl: './lead-partner-performance-list.component.html',
  styleUrls: ['./lead-partner-performance-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class LeadPartnerPerformanceListComponent implements OnInit {
  today = new Date();
  month = this.today.getMonth();
  year = this.today.getFullYear();
  startDate:string = moment().subtract(30, "days").format("YYYY-MM-DD HH:mm:ss");
  endDate:string = moment(this.today).format('YYYY-MM-DD HH:mm:ss');
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  columns = [
    {name: 'Lead Partner Title', property: 'leadPartnerTitle', visible: true},
    {name: 'Lead Count', property: 'leadCount', visible: true},
    { name: 'Actions', property: 'actions', visible: true },
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  campaignOne = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  campaignTwo = new FormGroup({
    start: new FormControl(new Date(this.year, this.month, 15)),
    end: new FormControl(new Date(this.year, this.month, 19)),
  });
  constructor(
    private apiservice: ApiService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.filterValue = 'Lead Partner Performance';
    this.router.onSameUrlNavigation = 'reload';

    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      this.getLeadPartnerPerformanceList();
    });
  }
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    
  }
  onFilterChange(value: any) {
    if (!this.dataSource) {return}
    value = value.trim();
    value = value.toLowerCase();
    this.dataSource.filter = value;
  }
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/lead-partners/lead-partner-performance-list?page=${this.pageIndex + 1
      }${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}`
    );
    this.getLeadPartnerPerformanceList();
  }

  getLeadPartnerPerformanceList() {
    this.apiservice.get(
        `admin/lead-partner/get-lead-partner-performance?page=${Number(this.pageIndex) + 1
        }&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''
        }&startDate=${this.startDate}&endDate=${this.endDate}`
      ).subscribe((res: any) => {     
       if (res.body) {
          if (res.body?.data?.data) {
            this.itemList = res.body?.data?.data;
            this.totalCount = res.body?.data?.total;
            this.dataSource = new MatTableDataSource(this.itemList);
            this.cdr.detectChanges();
          } else {
            this.itemList = undefined;
          }
        }
      });
  }

  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement){
    this.startDate = moment(this.campaignOne.value.start).format('YYYY-MM-DD HH:mm:ss');
    this.endDate = moment(this.campaignOne.value.end).format('YYYY-MM-DD HH:mm:ss');
    this.getLeadPartnerPerformanceList();
  };


}
